/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const investmentNeedFundingCardDtoSchema = z.object({
  kind: z.optional(z.string()),
  roundName: z.string().nullish(),
  amount: z.string().nullish(),
  equity: z.string().nullish(),
  stage: z.string().nullish(),
  preMoney: z.string().nullish(),
  postMoney: z.string().nullish(),
  entityName: z.optional(z.string()),
  entityUrl: z.optional(z.string()),
  entityType: z.optional(z.string()),
  entityTypeTone: z.optional(z.string()),
});
